import { AuthStep } from 'constants/authStep';

import { TranslationKey } from 'providers/i18n/types';

export const AUTH_STEPS_TITLES: Record<AuthStep, TranslationKey> = {
  [AuthStep.Credentials]: 'app.login.credentials',
  [AuthStep.ChangePassword]: 'app.login.newPassword',
  [AuthStep.SecondFactor]: 'app.login.secondFactor',
};
